import React from "react";
import styles from "../not-found/styles.module.scss";
import { Button, Typography } from "@material-ui/core";
import i18next from "i18next";


export function ErrorComponent({ error, resetErrorBoundary }: { error: any, resetErrorBoundary: any }) {
  return (
    <div className="container">
      <div className={`d-flex flex-wrap flex-column justify-content-center align-items-center text-light ${styles.error_container}`}>
        <Typography variant={"h2"}>{i18next.t("error_boundary.title")}</Typography>
        <p>{i18next.t("error_boundary.desc")}</p>
        <pre>{error.message}</pre>
        <Button variant="outlined" color="primary" onClick={resetErrorBoundary}>
          {i18next.t("error_boundary.reset")}
        </Button>
      </div>
    </div>
  );
};
